/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { CreateSurveyMarkSubmissions } from '../../models/create-survey-mark-submissions';
import { SurveyMarksSubmissionDto } from '../../models/survey-marks-submission-dto';

export interface CreateSurveyMarksSubmission$Params {
  body: CreateSurveyMarkSubmissions;
}

export function createSurveyMarksSubmission(
  http: HttpClient,
  rootUrl: string,
  params: CreateSurveyMarksSubmission$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SurveyMarksSubmissionDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    createSurveyMarksSubmission.PATH,
    'post',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyMarksSubmissionDto>;
      }),
    );
}

createSurveyMarksSubmission.PATH = '/me/surveyMarks/submissions';
